import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { CommonModule } from "@angular/common";
import { MedIconsModule } from "@mk/med-icons";

import { MedBreadcrumbComponent } from "./med-breadcrumb.component";
import { MedBreadcrumbService } from "./med-breadcrumb.service";

@NgModule({
  declarations: [
    MedBreadcrumbComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    MedIconsModule,
  ],
  providers: [
    MedBreadcrumbService,
  ],
  exports: [
    MedBreadcrumbComponent,
  ],
})
export class MedBreadcrumbModule { }
